// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ad":"ad-2W8BOxhs","box":"box-1qFKd4Hx","footer":"footer-12P55DBI"};